var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompany01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 28,
    viewBox: "0 0 23 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1992 13.7099L6.85156 11.1832V17.5827L11.1992 20.0886L22.3788 13.627V7.22754L11.1992 13.7099Z",
    fill: "#FFA000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2019 6.37878L16.212 9.27822L21.7397 6.08884L11.2019 0L0.664062 6.08884L6.15035 9.29894L11.2019 6.37878Z",
    fill: "#FFA000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5277 18.3283V10.4169L0 7.22754V21.5177L11.2003 28L22.3799 21.5177V15.1389L11.2003 21.6005L5.5277 18.3283Z",
    fill: "#FFA000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany01);
export default __webpack_public_path__ + "static/media/company-01.7ab868ce04d19e9567b26da91b219095.svg";
export { ForwardRef as ReactComponent };